import { render, staticRenderFns } from "./DebugView.vue?vue&type=template&id=0210bd04&"
import script from "./DebugView.vue?vue&type=script&lang=js&"
export * from "./DebugView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports